


function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Notifications')
  || allowed.includes('Messaging')
  || allowed.includes('Messages'))   {
    return [
    {
      title: 'Messaging',
      icon: 'mdi-message-text-outline',
      items: [
        {
          title: 'Messages', 
          icon: 'mdi-message-bulleted', 
          path: '/MsgMessages'
        }
      ]
    }
  ] } else return []
}

export default buildMenu

